/**
 * Mirrors frontend2's `SUPPORTTED_LOCALES` and core-api's `BRAND_LOCALES`, order
 * included — it is the order the locale chips read in. Not `ADMIN_LOCALES`,
 * which is the panel's own interface languages.
 */
export const PLAYER_LOCALES = [
  "en",
  "es",
  "fr",
  "hr",
  "pt",
  "de",
  "pl",
  "ru",
  "se",
  "dk",
  "ar",
  "sw"
] as const

export type PlayerSiteLocale = (typeof PLAYER_LOCALES)[number]

export const PLAYER_LOCALE_NAMES: Record<string, string> = {
  en: "English",
  es: "Español",
  fr: "Français",
  hr: "Hrvatski",
  pt: "Português",
  de: "Deutsch",
  pl: "Polski",
  ru: "Русский",
  se: "Svenska",
  dk: "Dansk",
  ar: "العربية",
  sw: "Kiswahili"
}

/** The language every other one falls back to when it has nothing of its own. */
export const FALLBACK_PLAYER_LOCALE = "en"
